import React from 'react';
import { Anchor, Box, DataTable, Tip } from 'grommet';
import PropTypes from 'prop-types';
import { EditCandidacyModalButton } from '../Jobs/EditCandidacyModalButton';

export const CandidacyTable = ({
    candidacies,
    companySlug,
    candidacyStatusEnums = [],
    onCandidacyUpdated,
}) => {
    const getJobUrl = (jobId) =>
        companySlug ? `/${companySlug}/jobs/${jobId}` : `/jobs/${jobId}`;

    const getCandidacyUrl = (jobId, candidacyId) =>
        companySlug
            ? `/${companySlug}/jobs/${jobId}/candidacies/${candidacyId}`
            : `/jobs/${jobId}/candidacies/${candidacyId}`;

    const filteredCandidacies = companySlug
        ? candidacies?.filter((candidacy) => {
            const slug =
                  candidacy.attributes?.job?.data?.attributes?.company?.data
                      ?.attributes?.slug;
            return slug?.toLowerCase() === companySlug?.toLowerCase();
        })
        : candidacies;

    const showEditColumn = candidacyStatusEnums.length > 0;

    const dataColumns = [
        {
            header: 'Job Title',
            primary: true,
            property: 'attributes.job.data.attributes.title',
            render: (candidacy) => {
                if (!candidacy?.attributes.job?.data?.attributes)
                    return 'Job Missing';

                return (
                    <Tip key={candidacy.id} content="click to view job">
                        <Anchor
                            href={getJobUrl(candidacy.attributes.job.data?.id)}
                            label={
                                candidacy.attributes.job.data?.attributes.title
                            }
                        />
                    </Tip>
                );
            },
            sortable: true,
        },
        {
            header: 'Status',
            property: 'attributes.status',
            render: (candidacy) => {
                return (
                    <Tip key={candidacy.id} content="click to view candidacy">
                        <Anchor
                            href={getCandidacyUrl(
                                candidacy.attributes.job.data?.id,
                                candidacy.id,
                            )}
                            label={candidacy.attributes.status}
                        />
                    </Tip>
                );
            },
            sortable: true,
        },
        {
            header: 'Last Updated',
            property: 'attributes.updatedAt',
            render: (candidacy) => {
                return new Date(
                    candidacy.attributes.updatedAt,
                ).toLocaleDateString('en-us', {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                });
            },
            sortable: true,
        },
        ...(showEditColumn
            ? [
                {
                    header: 'Action',
                    property: 'id',
                    sortable: false,
                    render: (candidacy) => (
                        <EditCandidacyModalButton
                            candidacy={{
                                id: candidacy.id,
                                status: candidacy.attributes.status,
                            }}
                            candidacyStatusEnums={candidacyStatusEnums}
                            onSaved={onCandidacyUpdated}
                        />
                    ),
                },
            ]
            : []),
    ];
    return (
        <Box>
            <DataTable
                primaryKey="id"
                sortable
                data={filteredCandidacies}
                columns={dataColumns}
            />
        </Box>
    );
};

CandidacyTable.propTypes = {
    candidacies: PropTypes.array,
    companySlug: PropTypes.string,
    candidacyStatusEnums: PropTypes.array,
    onCandidacyUpdated: PropTypes.func,
};
